import type { ApiResponse } from '@bitstopco/bitstop-theme';

import api from '@/store/api';
import { athena } from '@/store/api/instances';

export interface OccupationName {
  en: string;
  es: string;
  fr: string;
}

export interface OccupationIndustry {
  id: string;
  name: OccupationName;
}

export interface OccupationPosition {
  id: string;
  name: OccupationName;
}

export const occupationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOccupationIndustries: build.query<ApiResponse<OccupationIndustry[]>, void>({
      query: () => athena({ url: 'v2/resources/occupation-industries', method: 'GET' }),
    }),
    getOccupationPositions: build.query<ApiResponse<OccupationPosition[]>, void>({
      query: () => athena({ url: 'v2/resources/occupation-positions', method: 'GET' }),
    }),
  }),
});

export const { useGetOccupationIndustriesQuery, useGetOccupationPositionsQuery } = occupationApi;
